'use client'
import AdsContext from '@/context/ads'
import { cn } from '@/util/cn'
import { useContext } from 'react'

export const BOTTOM_LEADERBOARD_UNIT_NAME = 'bottom_leaderboard'
const BottomLeaderboardAd = () => {
    const { isHTLAdEnabled, pageName } = useContext(AdsContext)
    const className = `htlad-desktop_${BOTTOM_LEADERBOARD_UNIT_NAME}_${pageName}`
    const isEnabled = isHTLAdEnabled(BOTTOM_LEADERBOARD_UNIT_NAME)
    return isEnabled && <div className={cn(className, 'drop-shadow-[0_-4px_10px_rgba(0,0,0,.3)]')}></div>
}

export default BottomLeaderboardAd
